export default function UnavailableModal({ onClose }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6 space-y-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">Thông báo</h3>
                <p className="text-sm text-gray-500">
                    Tính năng này hiện chưa khả dụng với bạn. Nebula đang trong giai đoạn thử nghiệm nội bộ và sẽ sớm được mở rộng cho tất cả người dùng.
                </p>
                <button
                    onClick={onClose}
                    className="w-full px-4 py-2.5 bg-brand-blue-100 hover:bg-brand-blue-200 text-gray-700 text-sm font-medium rounded-xl transition-colors"
                >
                    Đã hiểu
                </button>
            </div>
        </div>
    );
}
